"use client";

import { useMotionValueEvent, useScroll, useSpring } from "motion/react";

const CX = 50;
const CY = 50;
const START_X = 75;
const START_Y = 30;
const RADIUS = Math.sqrt((START_X - CX) ** 2 + (START_Y - CY) ** 2);
const START_ANGLE = Math.atan2(START_Y - CY, START_X - CX);
const SWEEP = Math.PI / 12;

export const BackgroundPositionRotate: React.FC = () => {
  const { scrollYProgress } = useScroll();
  const smoothedProgress = useSpring(scrollYProgress, {
    stiffness: 80,
    damping: 20,
    mass: 1,
  });

  useMotionValueEvent(smoothedProgress, "change", (progress) => {
    const angle = START_ANGLE - progress * SWEEP;
    const x = CX + RADIUS * Math.cos(angle);
    const y = CY + RADIUS * Math.sin(angle);
    document.documentElement.style.setProperty(
      "--bg-rot-pos",
      `${x.toFixed(2)}% ${y.toFixed(2)}%`,
    );
  });

  return null;
};
